import { Attribute, EntitySchema } from '@epilot/entity-client'
import { TFunction } from 'react-i18next'

export const isReallyNaN = (value: any): boolean => {
  return value !== value
}

const hasTranslation = (t: TFunction, translationKey: string): boolean => {
  const translated = t(translationKey)

  return translated !== translationKey
}

export const getOptionLabel = ({
  t,
  schema,
  attributeName,
  value,
  label
}: {
  t: TFunction
  schema: EntitySchema['slug']
  attributeName: Attribute['name']
  value: string
  label: string
}): string | undefined => {
  if (value === undefined || value === null || value === '') {
    return undefined
  }

  const translationValueKey = `selectvalues.${schema}.${attributeName}.${value}`
  const translationLabelKey = `selectvalues.${schema}.${attributeName}.${label}`

  if (hasTranslation(t, translationValueKey)) {
    return t(translationValueKey)
  }

  if (hasTranslation(t, translationLabelKey)) {
    return t(translationLabelKey)
  }

  return value
}
